import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as ENV } from './../../../environments/environment';
import * as apiUrl from '../constants/api-urls';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecommendationService {
  api_url = `${ENV.API_ENDPOINT}`;
  constructor(private http: HttpClient) { }

  /** To get the list of scenarios */
  getScenarioList(params: any) {
    let url = this.api_url + apiUrl.recommendation.getScenarios
    return this.http.post(url, params)
  }

  /** get list of approvers for filters */
  getApproversList(payload: any) {
    let url = this.api_url + apiUrl.recommendation.approversList;
    return this.http.post(url, payload)
  }

  /** get list of in review for filters */
  getInReviewList(payload: any) {
    let url = this.api_url + apiUrl.recommendation.in_review_list
    return this.http.post(url, payload)
  }

  getApprovers(){
    let url = this.api_url + apiUrl.recommendation.approvers;
    return this.http.get(url)
  }

  /** get list of status for filters */
  getStatusList() {
    let url = this.api_url + apiUrl.recommendation.status_list;
    return this.http.get(url)
  }

  getScenarioFinalRecommendationHeaderDetails(payload: any){
    let url = this.api_url + apiUrl.recommendation.finalRecommendationListHeaders;
    return this.http.post(url, payload);
  }
  
  getScenarioFinalRecommendationPriceTierDetails(payload: any){
    let url = this.api_url + apiUrl.recommendation.finalRecommendationPriceTierTable;
    return this.http.post(url, payload);
  }
  
  getScenarioFinalRecommendationEstimatedImpactDetails(paylaod: any){
    let url = this.api_url + apiUrl.recommendation.estimatedImpact;
    return this.http.post(url, paylaod);
  }
  
  getScenarioFinalRecommendationSKUEstimatedImpactDetails(payload: any){
    let url = this.api_url + apiUrl.recommendation.estimatedImpactPriceBand;
    return this.http.post(url, payload);
  }
  
  getScenarioFinalRecommendationOriginalImpactDetails(payload: any){
    let url = this.api_url + apiUrl.recommendation.originalImpact;
    return this.http.post(url, payload);
  }
  
  getScenarioFinalRecommendationSKUOriginalImpactDetails(payload: any){
    let url = this.api_url + apiUrl.recommendation.originalImpactPriceBand;
    return this.http.post(url, payload);
  }

  private handleError<T>(result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  getSKUDetails(payload:any){
    let url = this.api_url + apiUrl.recommendation.skuDetails;
    return this.http.post(url, payload)
  }

  /**Category list api */
  getSKUCategoryDetails(payload:any){
    let url = this.api_url + apiUrl.recommendation.skuCategoryDetails;
    return this.http.post(url, payload)
  }

  /**Category list api */
  getPriceBandDetails(payload:any){
    let url = this.api_url + apiUrl.recommendation.skuPriceBandDetails;
    return this.http.post(url, payload)
  }

  /**Moe scenario to past */
  moveScenarioToPast(payload: any) {
    let url = this.api_url + apiUrl.recommendation.moveToPast;
    return this.http.post(url, payload);
  }

  /**move scenario to in market */
  moveScenarioToInMarket(payload: any) {
    let url = this.api_url + apiUrl.recommendation.moveToInMarket;
    return this.http.post(url, payload);
  }

  /**Category list api */
  getProductNameDetails(payload:any){
    let url = this.api_url + apiUrl.recommendation.skuProductNameDetails;
    return this.http.post(url, payload)
  }

  /** To get the count of SKU table */
  getSKUDetailsCount(params: any) {
    let url = this.api_url + apiUrl.recommendation.skuDetailsCount
    return this.http.post(url, params)
  }

  /** to get price band level chart data */
  getGraphData(payload: any) {
    let  url = this.api_url + apiUrl.recommendation.graphData;
    return this.http.post(url, payload);
  }

  getRangingSummaryTables(payload: any) {
    let  url = this.api_url + apiUrl.recommendation.rangingSummaryTable;
    return this.http.post(url, payload);
  }
  
  getRangingSummaryGraph(payload: any) {
    let  url = this.api_url + apiUrl.recommendation.rangingSummaryGraph;
    return this.http.post(url, payload);
  }
  
  getProductsDisplayDropdown() {
    let  url = this.api_url + apiUrl.recommendation.productsDisplayDropdown;
    return this.http.post(url, '');
  }

  /** List of price bands for price ranging screen */
  getPriceRangingPriceBandDetails(payload:any){
    let url = this.api_url + apiUrl.recommendation.priceRangingPriceBandDropdown;
    return this.http.post(url, payload)
  }
}
